// Quick Add By Size on image
document.querySelectorAll(".collectionItemImageQuickAddSize").forEach((el) => {
    el.addEventListener("click", handleQuickAdd);
});


// document.querySelectorAll(".collectionItemQuickAdd").forEach((el) => {
//     // Quick Add Event
//     el.addEventListener("click", async function (e) {
//         // Toggle the quick add menu
//         if (e.target.classList.contains("collectionItemQuickAddLabel")) {
//             el.classList.toggle("active");
//         }
//         // Add the item to the cart
//         else if (e.target.classList.contains("collectionItemQuickAddSize")) {
//             // .call binds the "this" context inside handleQuickAdd to the passed value, which in this case is the collectionItemQuickAddSize element
//             await handleQuickAdd.call(e.target);
//         }
//     });
// });

// Quick Add By Size on mobile
document.addEventListener("click", async function(e) {
    // Handle mobile quick add
    if (e.target.matches(".collectionItemQuickAddLabel")) {
        const quickAddContainer = e.target.closest(".collectionItemQuickAdd");
        if (quickAddContainer) {
            quickAddContainer.classList.toggle("active");
        }
    } else if (e.target.matches(".collectionItemQuickAddSize")) {
        const quickAddContainer = e.target.closest(".collectionItemQuickAdd");
        if (quickAddContainer) {
            await handleQuickAdd.call(e.target);
            // Close the quick add container after adding to cart
            quickAddContainer.classList.remove("active");
        }
    } else if (e.target.matches(".collectionItemImageFavorite")){
    }
});

async function handleQuickAdd() {
    const properties = {};

    // check for final sale
    if (this.dataset.finalSale) {
        properties["_finalSale"] = "Final Sale";
    }

    // check for ships by
    if (this.dataset.shipsBy) {
        properties["_shipsBy"] = this.dataset.shipsBy;
    }

    // add product to cart
    await addProduct({
        id: parseInt(this.dataset.variant),
        quantity: 1,
        properties: properties
    });

    // send klaviyo event
    klaviyoAddToCart(this.dataset.handle);
    
    await openCart();
}

// Favorite Button
document.addEventListener("click", function(e) {
    const favoriteBtn = e.target.closest(".collectionItemImageFavorite");
    if (favoriteBtn) {
        handleCollectionItemFavorite.call(favoriteBtn, e);
    }
});

// Check if product in wishlist
document.addEventListener("wishlistProductsLoaded", async () => {
    wishlistProducts.forEach(product => {
        if (document.querySelector(`.collectionItem[id="${product.id}"]`)) {
            document.querySelector(`.collectionItem[id="${product.id}"] .collectionItemImageFavorite`).classList.add("favorited");
        }
    });
});

async function handleCollectionItemFavorite() {
    this.classList.toggle("favorited");
    await addProductToWishlist(this.dataset.product);
}

// Update favorited state for collection items
function updateCollectionFavoritedButtons() {
  const wishlist = getWishlistProducts();
  if (!wishlist || !Array.isArray(wishlist)) return;
  wishlist.forEach(product => {
    const btn = document.querySelector(`.collectionItem[id="${product.id}"] .collectionItemImageFavorite`);
    if (btn) btn.classList.add('favorited');
  });
}

document.addEventListener("wishlistProductsLoaded", updateCollectionFavoritedButtons);
document.addEventListener("collectionItemsUpdated", () => {
  updateCollectionFavoritedButtons();
});

// On page load, if wishlistProducts is already available
if (getWishlistProducts() && Array.isArray(getWishlistProducts())) {
  updateCollectionFavoritedButtons();
}
